import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { errorHandler } from 'src/app/shared/helpers/error-handler';
import { AuthService } from 'src/app/shared/services/auth.service';
import { UserService } from 'src/app/shared/services/user.service';

@Component({
  selector: 'app-recover-password',
  templateUrl: './recover-password.component.html',
  styleUrls: ['./recover-password.component.scss']
})
export class RecoverPasswordComponent implements OnInit {

  document:any;
  emails:any[] = [];
  error:boolean = false;
  errorMsg:any;
  constructor(
    private dialogRef: MatDialogRef<RecoverPasswordComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private userService: UserService,
    private AuthService: AuthService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
  ) { }

  async ngOnInit() {
    if(this.data.document){
      this.document = this.data.document;
      this.emails = this.data.emails;
    }
  }

  async getEmails(){
    this.spinner.show();
    try{
      const result:any = (await this.userService.getEmails(this.document)).body;
      if(result.data){
        let obj = {
          personId: result.data.personId,
          primaryEmail: result.data.primaryEmail,
          email: result.data.primaryEmail,
          userName: this.document
        }

        this.emails.push(obj);
        result.data.companyPersonEmails.map((c)=>{
          let obj = {
            companyPersonId: c.companyPersonId,
            email: c.email,
            userName: this.document
          }
  
          this.emails.push(obj);
        })
      }
    }catch(error){
      this.error = true;
      this.errorMsg = error[0];
      this.toastr.error(errorHandler(error), 'Erro!');
    }finally{
      this.spinner.hide();
    }
  }

  async selectEmail(email){
    this.spinner.show();
    try{
      let resultEmail:any = {...email};
      if(resultEmail.personId){
        delete resultEmail.primaryEmail;
        delete resultEmail.email;
      }
      const result:any = (await this.AuthService.forgotPassword(resultEmail));
      this.toastr.success(
        'Acesse seu email para alterar a senha',
        'Sucesso!'
      );
      this.dialogRef.close();
    }catch(error){
      this.toastr.error(errorHandler(error), 'Erro!');
    }finally{
      this.spinner.hide();
    }
  }

}
